import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { BaseModel } from "../Generics/BaseModel"

export class AddtionalEntity extends BaseModel {
  id: number

  name: string

  description: string

  iconUrl: string

  value: string

  status: EEnableStatusType

  isOutOfStock: boolean

  hasStockControl: boolean

  stockQuantity: number

  constructor(data: Partial<AddtionalEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.iconUrl = data.iconUrl ?? ""

    this.value = data.value ?? ""

    this.status = data.status ?? EEnableStatusType.Active

    this.isOutOfStock = data.isOutOfStock ?? false

    this.hasStockControl = data.hasStockControl ?? false

    this.stockQuantity = data.stockQuantity ?? 0
  }
}
